<template>
  <v-container 
    style="
      padding: 0;
    "
  >
    <v-row>
      <v-navigation-drawer
        app
        fixed
        temporary
        v-model="drawer"
      >
        <v-list>
          <v-list-item
            v-for="page in menuPages"
            :key="page.id"
            :to="page.action ? undefined : page.path"
            :link="!page.action"
            @click="page.action === 'signOut' ? handleSignOut() : null"
          >
            <v-list-item-icon>
              <v-icon> {{page.icon}} </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{page.text}}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
      <v-app-bar
        color='rgba(0,0,0,0)'
        flat
        dark
        app
        v-if="dark"
      >
        <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
        
        <v-spacer></v-spacer>
        <v-btn 
          icon
          class="h3 ma-3"
          @click="toSignIn"
        >
          Sign In
        </v-btn>
      </v-app-bar>
      <v-app-bar
        height="83px"
        color='#E9E5DD'
        flat
        app
        v-else
      >
        <v-btn
          class="mx-7"
          color="#999999"
          icon
          @click="toHome"
        >
          <v-img 
            max-width="79px"
            src="../assets/CF_Logo.png"
          ></v-img>
        </v-btn>

        <v-divider
          class="mx-5"
          vertical
        ></v-divider>

        <v-app-bar-nav-icon
          @click="drawer = !drawer"
          v-if="!user.email"
        ></v-app-bar-nav-icon>
        
        <v-spacer></v-spacer>
        <v-btn 
          icon
          class="h3 ma-3"
          @click="toSignIn"
          v-if="!user.email"
        >
          Sign In
        </v-btn>
        <v-btn 
          icon
          class="h3 ma-3"
          @click="signOut"
          v-if="user.email"
        >
          Sign Out
        </v-btn>
      </v-app-bar>
    </v-row>
    <v-row v-if="user.email">
      <v-col class="text-left pr-5" cols="6">
        <h2 class="title text-uppercase">{{ user.email }}</h2>
      </v-col>
      <v-col v-if="showBackButton" class="text-right pr-5" cols="6">
        <v-btn class="ma-5" @click="toTenantLanding">BACK</v-btn>
      </v-col>
      <v-col v-else-if="showManageBilling && user.stripeAccountExists" @click="redirectToStripeAccountManagement()" class="text-right pr-5" cols="6">
        <v-btn class="ma-5">Manage Billing</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import router from '../router'
import { DB } from '../firebase/db'
import { Functions } from '../firebase/functions'

const createPortalSession = Functions.httpsCallable('createPortalSession')

export default {
  name: 'StatusBar',
  props: {
    showCompletedButton: {
      type: Boolean,
      default: false,
    },
    showManageBilling: {
      type: Boolean,
      default: false,
    },
    showBackButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      drawer: false,
    }
  },
  computed: {
    ...mapState(['user']),
    menuPages() {
      const basePages = [
        { id: 0, path: '/', name: 'Home', icon: 'mdi-home', text: 'Home' },
        {
          id: 1,
          path: '/contact-us',
          name: 'ContactUs',
          icon: 'mdi-home',
          text: 'Contact Us',
        },
      ]
      const authPage = this.user.email
        ? { id: 2, text: 'Sign Out', icon: 'mdi-home', action: 'signOut' }
        : { id: 2, path: '/sign-in', name: 'SignIn', icon: 'mdi-home', text: 'Sign In' }
      return [...basePages, authPage]
    },
    dark() {
      if(this.$route.name === 'Home') {
        return true
      } else {
        return false
      }
    },
    uid: function() {
      return this.$store.state.user.uid
    }
  },
  methods: {
    signOut() {
      this.$store.dispatch('signOut')
    },
    handleSignOut() {
      this.drawer = false
      this.signOut()
    },
    toSignIn() {
      if(this.$route.name !== 'SignIn') {
        router.push({ name: 'SignIn' })
      }
    },
    toHome() {
      if(this.$route.name !== 'Home') {
        router.push({ name: 'Home' })
      }
    },
    toTenantLanding() {
      if(this.$route.name !== 'TenantLanding') {
        router.push({ name: 'TenantLanding' })
      }
    },
    async redirectToStripeAccountManagement() {
      let customer = await DB.collection('user')
        .doc(this.uid)
        .collection('stripe')
        .doc('stripe_customer')
        .get()
        
      let session = await createPortalSession({
        customer: customer.data().stripe_customer_id
      })

      location.href = session.data.session.url
    }
  },
}
</script>

<style scoped>

</style>